import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const annotationFields = [
  "annotationid",
  "subject",
  "notetext",
  "createdon",
  "objectid_gaming_gameconcept",
] as const;

export const annotationReferences: EntityReferences<EntityName.annotation> = {
  [EntityName.gaming_gameconcept]: ["objectid_gaming_gameconcept"],
};

export const annotationKey: AnyEntityField<EntityName.annotation> = "annotationid";
